export default {"src":"/_next/static/media/wallet_money_24.5ee442eb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};